import styled from 'styled-components'
import { GRAY, LIGHTERGRAY, BLUE } from '../../../../styles/colors.style'
import Browser from '../../../../services/Browser'
import { breakpoints } from '../../../../constants/breakpoints.constants'
import { ieStyle } from '../../../../modules/private/client/points-purchase/styles.style'

const StyledChangeAddressModalBody = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	& > *:not(:last-child) {
		margin-bottom: 4rem;
	}

	.add-address {
		color: ${BLUE};
		font-size: 20px;
		padding: 15px;
		border: 1px dashed ${GRAY};
		border-radius: 5px;
		background: ${LIGHTERGRAY};
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		transition: all 0.5s;

		${Browser.isIE() ? 'width:205px;' : ''} &:hover {
			cursor: pointer;
			border-color: ${BLUE};
			background: transparent;
			transition: all 0.5s;
		}
	}

	.addresses {
		display: grid;
		grid-gap: 15px;
		width: 100%;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			grid-template-columns: repeat(3, 1fr);
			display: ${Browser.isIE() ? 'flex' : 'grid'};
			flex-wrap: wrap;
		}

		& > *:not(:last-child) {
			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				margin-right: ${Browser.isIE() ? '15px' : null};
				margin-bottom: ${Browser.isIE() ? '15px' : null};
			}
		}

		${Browser.isIE() ? ieStyle : ''};
	}
`

export default StyledChangeAddressModalBody
